export const BuildInfo = {timestamp:1777742620000}
